
import { defineComponent, inject, computed } from "vue";
import CiBreadcrumbs from "@components/base/breadcrumbs.vue";

export default defineComponent({
  name: "CiContentHubGeneric",

  components: { CiBreadcrumbs },

  setup() {
    // Tags methods
    const breadCrumbs: ContentHubs.BreadCrumb[] = inject("breadCrumbs", []);
    const tagNames: any = inject("tagNames", []);
    const lastTag = computed((): string => tagNames.value[tagNames.value.length - 1]);

    return {
      lastTag,
      breadCrumbs,
    };
  },
});
